export const UPDATE_PAYMENT_SETTINGS = 'UPDATE_PAYMENT_SETTINGS';
export const UPDATE_PAYMENT_AMOUNT = 'UPDATE_PAYMENT_AMOUNT';
export const RECEIVE_PAYMENT_AUTHORIZATION = 'RECEIVE_PAYMENT_AUTHORIZATION';

export const updatePaymentSettings = ({ enabled, paymentApiKey }) => ({
  type: UPDATE_PAYMENT_SETTINGS,
  data: { enabled, paymentApiKey },
});

export const updatePaymentAmount = ({ amountDue, formattedAmountDue }) => ({
  type: UPDATE_PAYMENT_AMOUNT,
  data: { amountDue, formattedAmountDue },
});

export const receivePaymentAuthorization = (paymentAuthorization) => async (dispatch) => {
  await dispatch({
    type: RECEIVE_PAYMENT_AUTHORIZATION,
    data: paymentAuthorization,
  });
};
